import req from "./https.js";

// if(!CURRENCY && isAllowedWithoutCurrency(window.location.pathname) === false) {
//   toLogin();
// }

// const CURRENCY = getCurrency();

export const request = (method, path, data = null, needAuth = true) =>
  req(method, `${process.env.REACT_APP_apiUrl}${path}`, data, needAuth);

// export const requestData = (method, path, data = null, needAuth = false) =>
//   req(method, `${PROTOCOL}://${DATA_API}${path}`, data, needAuth);

// export const requestMain = (method, path, data = null, needAuth = false) =>
//   req(method, `${PROTOCOL}://${MAIN_API}${path}`, data, needAuth);

// export const requestLogin = (method, path, data = null, needAuth = false) =>
//   req(method, `${PROTOCOL}://${LOGIN_API}${path}`, data, needAuth);

// export const requestPayment = (method, path, data = null, needAuth = false) =>
//   req(method, `${PROTOCOL}://${PAYMENT_API}${path}`, data, needAuth);

export const requestImage = (method, path, data = null, needAuth = false) =>
  req(method, `${process.env.REACT_APP_IMAGE_SERVER}${path}`, data, needAuth);
